import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MagicLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      return;
    }
    verifyToken();
  }, [token]);

  const verifyToken = async () => {
    try {
      const response = await axios.post(`${API}/auth/verify-magic-link`, { token });
      
      localStorage.setItem('lembrou_token', response.data.token);
      localStorage.setItem('lembrou_user', JSON.stringify(response.data.user));
      
      setStatus('success');
      toast.success('Login realizado com sucesso!');
      
      setTimeout(() => {
        if (response.data.user.tipo_usuario === 'PF') {
          navigate('/timeline');
        } else {
          navigate('/dashboard');
        }
      }, 1500);
    } catch (error) {
      setStatus('error');
      if (error.response?.status === 400) {
        toast.error('Link expirado ou inválido');
      } else {
        toast.error('Erro ao fazer login');
      }
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-red-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 rounded-3xl shadow-xl border-0">
        <div className="text-center">
          {status === 'loading' && (
            <>
              <Loader2 className="w-16 h-16 text-primary animate-spin mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Verificando...</h2>
              <p className="text-gray-600">Aguarde um momento</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-4">
                <CheckCircle2 className="w-8 h-8 text-green-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Login realizado!</h2>
              <p className="text-gray-600">Redirecionando...</p>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 mb-4">
                <XCircle className="w-8 h-8 text-red-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Link Inválido</h2>
              <p className="text-gray-600 mb-6">Este link expirou ou é inválido</p>
              <button
                onClick={() => navigate('/auth')}
                className="text-primary hover:underline"
              >
                Voltar para login
              </button>
            </>
          )}
        </div>
      </Card>
    </div>
  );
};

export default MagicLogin;